
const MegaMenu = function() {
    function MegaMenu() {
        this.selector = {
            menus: document.querySelectorAll('.mega-menu__list .mega-menu__link'),
            gridThumbnails: document.querySelectorAll('.mega-menu-grid-list .card-wrapper'),
            gridList: document.querySelectorAll('.mega-menu-grid-list-container .mega-menu-grid-list')
        }
        this.load();
    }
    MegaMenu.prototype.load = function() {
        var _ = this;
        if(_.selector.menus.length > 0) {           
            _.selector.menus.forEach(menu => {
                menu.addEventListener('mouseover', event => {
                   if(_.selector.gridThumbnails.length > 0) {
                        _.selector.gridThumbnails.forEach(thumbnail => {
                            if(event.target.closest('.mega-menu__link').dataset.linkHandle === thumbnail.dataset.linkHandle) {
                                thumbnail.classList.add('hover');
                            } else {
                                thumbnail.classList.remove('hover');
                            }
                        })
                   }
                })
            })
        }
        if(_.selector.gridList.length > 0) {
            _.selector.gridList.forEach(grid => {
                grid.addEventListener('mouseover', () => {
                    if(_.selector.gridThumbnails.length > 0) {
                        _.selector.gridThumbnails.forEach(thumbnail => {
                            thumbnail.classList.remove('hover');
                        })
                    }
                })
            })
            
        }
    }
    MegaMenu = new MegaMenu;
}
MegaMenu();
